// extracted by mini-css-extract-plugin
export default {"dropZone":"dSuL78JrkYkoBYv2PgCR","dropZoneOver":"RLsWXknlY8sNUiGbK3KG"};